import axios from "axios";
import Webcam from "react-webcam";
import { useRef, useState } from "react";
import { FaStop } from "react-icons/fa6";
import { toast, Bounce } from "react-toastify";
import { HiCamera } from "react-icons/hi";
import Retake from "src/assets/retake.png";
import { TiArrowBack } from "react-icons/ti";
import { FaRegStopCircle } from "react-icons/fa";
import { CiPause1, CiVideoOn } from "react-icons/ci";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { IoCameraOutline, IoCloudUpload } from "react-icons/io5";
import { MdOutlineFlipCameraIos, MdOutlineCamera } from "react-icons/md";
import { CircularProgress } from "@mui/material";
import Cookies from "js-cookie";
import CONSTANTS from "src/components/services/api";

const CameraComponent = ({
  setShowCamera,
  handleUpload,
  setLoading,
  close,
  loading,
}) => {
  const bearerToken = Cookies.get("Token");
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const recordingIntervalRef = useRef(null);

  const [mode, setMode] = useState(null); // 'photo' | 'video'
  const [cameraError, setCameraError] = useState(false);

  const [capturedImage, setCapturedImage] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  const [recordedChunks, setRecordedChunks] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0); // timer state
  const [stopRecordingState, setStopRecordingState] = useState(false);

  const base64ToBlob = (base64) => {
    const byteString = atob(base64.split(",")[1]);
    const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const handleCapture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const handlePhotoUpload = async () => {
    const blob = base64ToBlob(capturedImage);
    const file = new File([blob], "captured_image.jpg", { type: "image/jpeg" });
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    const newFormData = new FormData();
    newFormData.append("file[]", file);
    newFormData.append("file_id", "95345234gsdg395");
    newFormData.append("subscription_id", String(showChat._id));

    try {
      setLoading(true);
      const response = await axios.post(
        `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
        newFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: bearerToken,
          },
        }
      );
      handleUpload(response.data);
      setShowCamera(false);
    } catch (error) {
      console.error("Photo Upload Error:", error);
      toast.error(error?.message || "Error to upload the media", {
        position: "top-center",
        autoClose: 1000,
        transition: Bounce,
      });
    } finally {
      close();
      setLoading(false);
    }
  };

  const startRecording = () => {
    setRecordedChunks([]);
    setRecordingTime(0);
    const stream = webcamRef.current.stream;
    const mediaRecorder = new MediaRecorder(stream, { mimeType: "video/webm" });
    mediaRecorderRef.current = mediaRecorder;

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        setRecordedChunks((prev) => [...prev, event.data]);
      }
    };

    mediaRecorder.start();
    setIsRecording(true);
    setIsPaused(false);

    recordingIntervalRef.current = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);
  };
  const pauseRecording = () => {
    mediaRecorderRef.current.pause();
    setIsPaused(true);
    clearInterval(recordingIntervalRef.current);
  };

  const resumeRecording = () => {
    mediaRecorderRef.current.resume();
    setIsPaused(false);

    recordingIntervalRef.current = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setIsRecording(false);
    setStopRecordingState(true);
    clearInterval(recordingIntervalRef.current);
  };

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  const generateThumbnail = (videoFile) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const url = URL.createObjectURL(videoFile);
      video.src = url;
      video.preload = "metadata";
      video.muted = true;
      video.playsInline = true;

      video.onloadedmetadata = () => {
        video.currentTime = 0;
      };

      video.onseeked = () => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const thumbnailDataUrl = canvas.toDataURL("image/png");
        resolve(thumbnailDataUrl);
        URL.revokeObjectURL(url);
      };

      video.onerror = () => {
        reject(new Error("Error loading video data"));
      };
    });
  };

  const handleVideoUpload = async () => {
    const file = new Blob(recordedChunks, { type: "video/webm" });
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    const thumb = await generateThumbnail(file);

    const newFormData = new FormData();
    newFormData.append("file[]", file);
    newFormData.append("file_id", "95345234gsdg395");
    newFormData.append("subscription_id", String(showChat._id));
    newFormData.append("thumbnail[]", thumb);

    try {
      setLoading(true);
      const response = await axios.post(
        `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
        newFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: bearerToken,
          },
        }
      );
      handleUpload(response.data, "0", "video");
      setShowCamera(false);
    } catch (error) {
      console.error("Video Upload Error:", error);
      toast.error(error?.message || "Error to upload the media", {
        position: "top-center",
        autoClose: 1000,
        transition: Bounce,
      });
    } finally {
      close();
      setLoading(false);
    }
  };

  const renderInitialScreen = () => (
    <div className="text-white flex flex-col gap-6 items-center justify-center">
      <h2 className="text-2xl font-bold">What would you like to do?</h2>
      <div className="flex gap-4 mt-4">
        <button
          className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
          onClick={() => setMode("photo")}
        >
          <IoCameraOutline className="mr-1" size={25} />
          Capture Photo
        </button>
        <button
          className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
          onClick={() => setMode("video")}
        >
          <CiVideoOn className="mr-1" size={25} />
          Record Video
        </button>
      </div>
    </div>
  );

  const renderPhotoScreen = () => {
    return !capturedImage ? (
      <div className="relative w-full h-full">
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          className="w-full h-full object-cover"
          onUserMediaError={() => setCameraError(true)}
        />
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex gap-x-3">
          <button
            onClick={handleCapture}
            className="bg-white text-black px-4 py-2 rounded flex items-center"
          >
            <HiCamera className="mr-1" size={25} /> Capture
          </button>
          <button
            onClick={() => setShowCamera(false)}
            className="bg-white text-black px-6 py-2 rounded flex items-center"
          >
            <TiArrowBack className="mr-1" size={25} /> Back
          </button>
        </div>
      </div>
    ) : (
      <div className="flex flex-col items-center">
        <img
          src={capturedImage}
          alt="Captured"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-9 flex flex-col md:flex-row md:space-x-6 gap-y-1">
          <button
            className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
            onClick={handlePhotoUpload}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress className="!h-7 !w-7 !text-black" />
            ) : (
              <>
                <MdOutlineFlipCameraIos className="mr-1" size={25} />
                Proceed
              </>
            )}
          </button>
          <button
            className="bg-[#FBCBCD] text-[#76767C] px-7 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
            onClick={() => setShowCamera(false)}
          >
            <MdOutlineCamera className="mr-1" size={25} />
            Close
          </button>
          <button
            className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
            onClick={() => setCapturedImage(null)}
          >
            <img src={Retake} alt="retake" className="h-5 mr-2" />
            Re-take
          </button>
        </div>
      </div>
    );
  };

  const renderVideoScreen = () => (
    <div className="relative w-full h-full">
      <Webcam
        ref={webcamRef}
        audio={true}
        className="w-full h-full object-cover"
        onUserMediaError={() => setCameraError(true)}
      />

      {isRecording && (
        <div className="absolute top-5 left-1/2 bg-white text-black px-3 py-1 rounded-lg shadow-lg text-sm font-semibold">
          ⏺ {formatTime(recordingTime)}
        </div>
      )}

      <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-4">
        {!stopRecordingState && !isRecording && (
          <div className="flex gap-x-3">
            <button
              onClick={startRecording}
              className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
            >
              <FaRegStopCircle className="mr-1" size={25} /> Start Recording
            </button>
            <button
              onClick={() => setShowCamera(false)}
              className="bg-white text-[#76767C] px-12 py-2 rounded-2xl shadow-lg flex items-center"
            >
              <TiArrowBack className="mr-1" size={25} /> Back
            </button>
          </div>
        )}

        {isRecording &&
          (isPaused ? (
            <button
              onClick={resumeRecording}
              className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
            >
              <FaRegStopCircle className="mr-1" size={25} /> Resume
            </button>
          ) : (
            <button
              onClick={pauseRecording}
              className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
            >
              <CiPause1 className="mr-1" size={25} /> Pause
            </button>
          ))}
        {/* {!isRecording && (
          <button onClick={startRecording} className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm">
            <FaRegStopCircle className="mr-1" size={25} /> Start Recording
          </button>
        )} */}
        {isPaused && !stopRecordingState && (
          <button
            onClick={stopRecording}
            className="bg-[#FBCBCD] text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm"
          >
            <FaStop className="mr-1" size={25} />
            Stop Recording
          </button>
        )}
      </div>

      {isPaused && recordedChunks.length > 0 && (
        <button
          onClick={handleVideoUpload}
          className="bg-white text-[#76767C] px-5 py-5 h-5 rounded-2xl shadow-lg flex items-center text-sm absolute bottom-5 left-1/2 transform -translate-x-5"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress className="!h-7 !w-7 !text-black" />
          ) : (
            <>
              <IoCloudUpload className="mr-1" size={25} /> Upload Video
            </>
          )}
        </button>
      )}
    </div>
  );

  return (
    <div className="w-full h-full bg-black flex flex-col items-center justify-center relative">
      <div className="absolute top-2 right-2 cursor-pointer">
        <IoMdCloseCircleOutline
          size={30}
          color="white"
          onClick={() => {
            setShowCamera(false);
            close();
          }}
        />
      </div>

      {cameraError ? (
        <div className="text-white flex flex-col items-center gap-y-5">
          <h1 className="text-2xl font-bold">Camera Not Found</h1>
          <p className="text-md w-[60%] text-center">
            Please check your camera permissions or try again.
          </p>
          <button
            className="mt-4 bg-red-500 text-white px-4 py-1 rounded-lg"
            onClick={() => {
              setShowCamera(false);
              close();
            }}
          >
            Okay! Got it.
          </button>
        </div>
      ) : mode === null ? (
        renderInitialScreen()
      ) : mode === "photo" ? (
        renderPhotoScreen()
      ) : (
        renderVideoScreen()
      )}
    </div>
  );
};

export default CameraComponent;
